import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import orderSlice from "./slices/orderSlice";
import companySlice from "./slices/companySlice";
import teamMemberClientSlice from "./slices/TeamMemberClientSlice";
import stripeSlice from "./slices/paymentSlice";
import invoiceSlice from "./slices/invoiceSlice";
import aiWorkflowPlanSlice from "./slices/aiWorkFlowSlice";
import threadSlice from "./slices/threadSlice";
import { injectStore } from "../config/api";

const store = configureStore({
  reducer: {
    auth: authSlice,
    company: companySlice,
    order: orderSlice,
    teamMemberClient: teamMemberClientSlice,
    stripe: stripeSlice,
    invoice: invoiceSlice,
    aiWorkflowPlan: aiWorkflowPlanSlice,
    thread: threadSlice,
  },
});

injectStore(store);

export default store;

// INFO: Exporting auth actions and thunks
export {
  logout,
  openSignInModal,
  closeSignInModal,
  handleSessionExpiration,
  setIntendedRoute,
} from "./slices/authSlice";

export { getUserProfile, updateUserProfile } from "./thunks/userThunks";

export {
  getCompanyProfile,
  updateCompanyProfile,
} from "./thunks/companyThunks";

export {
  inviteTeamMemberClient,
  getTeamMembers,
  validateInvitationToken,
  removeTeamMemberClient,
} from "./thunks/teamMemberClientThunks";

export {
  clearStripeError,
  clearStripeData,
  setStripeConnectStatus,
} from "./slices/paymentSlice";

export {
  setOrderChat,
  updateLastMessage,
  updateLastMessageDeliveredToAll,
  updateLastMessageReadByAll,
  clearOrderChat,
  participantJoined,
  participantLeft,
  updateThreadInfo,
} from "./slices/orderSlice";

export { createTestCookie, updateCookie } from "./thunks/consentThunks";

export * from "./thunks/authThunks";
export * from "./thunks/userThunks";
export * from "./thunks/orderThunks";
export * from "./thunks/threadThunks";
export * from "./thunks/companyThunks";
export * from "./thunks/teamMemberClientThunks";
export * from "./thunks/consentThunks";
export * from "./thunks/offerThunks";
export * from "./thunks/paymentThunks";
export * from "./thunks/subscriptionThunks";
export * from "./thunks/aiWorkFlowThunks";
